import { useMutation, useQueryClient } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { productService } from 'services';

export const useDownloadAsset = (refetchHistory?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation(
    (sku: string) => {
      return productService.downloadAsset(sku);
    },
    {
      onSuccess: () => {
        if (refetchHistory) {
          queryClient.invalidateQueries([ServerStateKeysEnum.downloadsHistory]);
        }
      },
    }
  );
};
